var $ = require('jquery');
var slick = require('slick-carousel');

module.exports = {
	init: function () {

        console.log('Running sliders.js');

        // Slider types
        var sliderListing = $('.layout.listing-slider .deck-of-cards');
        var sliderWithNav = $('.layout.slider-with-nav');
        var slider = $('.layout.slider .items');

        // Slider dot settings
        // Limit to display five dots at a time
        var maxDots = 5;
        var transformCount = 0;
        var transformXIntervalNext = -18;
        var transformXIntervalPrev =  18;
        var setBoundries = function(slick, state) {
            if (state === 'default') {
                slick.find('ul.slick-dots li').eq(maxDots).addClass('n-small-1');
            }
        };
        
        slider.on('init', function (event, slick) {
            $(this).find('ul.slick-dots').wrap('<div class="slick-dots-container"></div>');
            $(this).find('ul.slick-dots li').each(function (index) {
                $(this).addClass('dot-index-' + index);
            });
            $(this).find('ul.slick-dots').css('transform', 'translateX(0)');
            setBoundries($(this),'default');
        }).on('breakpoint', function (event, slick) {
            $(this).find('ul.slick-dots').wrap('<div class="slick-dots-container"></div>');
            $(this).find('ul.slick-dots li').each(function (index) {
                $(this).addClass('dot-index-' + index);
            });
            $(this).find('ul.slick-dots').css('transform', 'translateX(0)');
            setBoundries($(this),'default');
        });

        // Begin slider inits

        // Sliders in listing layouts
        if (sliderListing.length > 0) {
            for (var i = 0; i < sliderListing.length; i++) {
                $(sliderListing[i]).slick();
            }
        }

        // Sliders w/ nav
        if (sliderWithNav.length > 0) {
            for (var i = 0; i < sliderWithNav.length; i++) {
                var main = $(sliderWithNav[i]).find('.items');
                var nav = $(sliderWithNav[i]).find('.items-nav');

                window.addEventListener('load', function () {
                    if ( window.innerWidth < 768 ) {
                        // Init first slider
                        $(main).slick();
                    } else if ( window.innerWidth > 768 ) {
                        // Init first slider
                        $(main).slick();
                        // Init nav slider
                        $(nav).slick();
                    }
                });
                window.addEventListener('resize', function() {
                    if ( window.innerWidth < 768 && $(nav).hasClass('slick-initialized') ) {
                        $(nav).slick('unslick');
                    } else if ( window.innerWidth > 768 && !$(nav).hasClass('slick-initialized') ) {
                        $(nav).slick();
                    }
                });
            }
        }

        // All other sliders
        if (slider.length > 0) {
            for (var i = 0; i < slider.length; i++) {
                $(slider[i]).slick();
            }
        }

        slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            // console.log('Running the beforeChange event.');
            var totalCount = $(this).find('.slick-dots li').length;
            // console.log('Total dots: ' + totalCount);
            // console.log('Next slide: ' + nextSlide + ' Current slide: ' + currentSlide);
            if (totalCount > maxDots) {
                if (nextSlide > currentSlide) {
                    // console.log('Next slide is > current slide.');
                    if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('n-small-1')) {
                        if (!$(this).find('ul.slick-dots li:last-child').hasClass('n-small-1')) {
                            transformCount = transformCount + transformXIntervalNext;
                            // console.log('Transform count: ' + transformCount + ' Transform interval next: ' + transformXIntervalNext);
                            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('n-small-1');
                            var nextSlidePlusOne = nextSlide + 1;
                            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-small-1');
                            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                            var pPointer = nextSlide - 4;
                            var pPointerMinusOne = pPointer - 1;
                            $(this).find('ul.slick-dots li').eq(pPointerMinusOne).removeClass('p-small-1');
                            $(this).find('ul.slick-dots li').eq(pPointer).addClass('p-small-1');
                        }
                    }
                }
                else {
                    // console.log('Next slide is < current slide.');
                    if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('p-small-1')) {
                        if (!$(this).find('ul.slick-dots li:first-child').hasClass('p-small-1')) {
                            transformCount = transformCount + transformXIntervalPrev;
                            // console.log('Transform count: ' + transformCount + ' Transform interval prev: ' + transformXIntervalPrev);
                            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('p-small-1');
                            var nextSlidePlusOne = nextSlide - 1;
                            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-small-1');
                            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                            var nPointer = currentSlide + 3;
                            var nPointerMinusOne = nPointer - 1;
                            $(this).find('ul.slick-dots li').eq(nPointer).removeClass('n-small-1');
                            $(this).find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-small-1');
                        }
                    }
                }
            }
        });

	}
}